<template>
<div class="test-edit-form">
    <test-page-header
        :title="trans.edit_form.form_title"
        :is-one-line-title="true"
        :return-button="returnButton"
    />

    <div class="card p-1 mb-1 test-is-already-edit" v-if="!isCanEdit">
        <p>
            {{ trans.edit_form.only_view }}
        </p>
        <p>{{editSession.name}} ({{editSession.email}})</p>
    </div>

    <div class="fixed-with-overflow-y small-scrollbar">
        <div class="test-edit-tabs">
            <tabs>
                <tab :name="trans.edit_form.tabs.main_label" :selected="true">
                    <test-edit-main-tab/>
                </tab>
                <tab :name="trans.edit_form.tabs.settings_label">
                    <test-edit-settings-tab/>
                </tab>
            </tabs>
        </div>
        <div class="label test-question-list-label">
            {{ trans.edit_form.questions_section_label }}
        </div>
        <question-list/>
        <question-create-button v-if="isCanEdit"/>
    </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TestPageHeader from "../TestPageHeader";
import Tabs from "../../../utils/tabs/Tabs";
import Tab from "../../../utils/tabs/Tab";
import TestEditSettingsTab from "./tabs/TestEditSettingsTab";
import TestEditMainTab from "./tabs/TestEditMainTab";

export default {
    name: "TestEditForm",
    components: {
        TestEditMainTab,
        TestEditSettingsTab,
        Tab,
        Tabs,
        TestPageHeader
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testEditor',
            'editSession',
            'isCanEdit',
        ]),
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnToTestListPage,
            }
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestListPage',
        ]),
    },
}
</script>

<style lang="scss">
@import '../../../../../sass/variables';

.bulma {
    .test-edit-form .test-edit-tabs .tabs-container {
        .tabs li {
            &.is-active {
                border-bottom: 2px solid $tests-blue;
                a {
                    background: none;
                }
            }

            a {
                font-size: 1rem;
                font-weight: 600;
            }
        }

        .tabs-details {
            background: none;
            padding-left: 0;
            padding-right: 0;
        }
    }
}

.test-edit-form {
    .column {
        display: flex;
    }

    .label {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 19px;
        text-align: left;
        min-width: 137px;
        align-self: center;

        &_min {
            font-size: 1rem;
        }
    }

    .test-question-list-label {
        margin: 25px 0 20px 0;
    }

    .card.test-is-already-edit {
        font-size: 1rem;
        line-height: 1.2;
        overflow: inherit;
    }
}
</style>
